export type PlaceholderConfig = {
  text: string;
};

export const defaultConfig: PlaceholderConfig = {
  text: "Lorem Ipsum",
};

export default defaultConfig;
